import { useEffect } from 'react';

const GTM_ID = 'GTM-WMKF7FQD';
const COOKIE_CONSENT_KEY = 'agencia_ppc_cookie_consent';

/**
 * Google Tag Manager Loader
 * Only loads GTM if the user has accepted analytics cookies (GDPR compliance)
 */
const GTMLoader = () => {
  useEffect(() => {
    const loadGTM = () => {
      // Check if GTM is already loaded
      if (window.gtmLoaded) return;

      // Check consent
      const consentStr = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!consentStr) return;

      try {
        const consent = JSON.parse(consentStr);
        if (!consent.analytics) return;

        // Load GTM script
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', GTM_ID);

        // Add noscript iframe to body
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);

        window.gtmLoaded = true;
        console.log('GTM loaded after consent');
      } catch (e) {
        console.error('Error loading GTM:', e);
      }
    };

    // Load on mount if consent exists
    loadGTM();

    // Listen for consent changes (custom event from CookieBanner)
    const handleConsentChange = () => {
      loadGTM();
    };

    window.addEventListener('cookieConsentChanged', handleConsentChange);

    return () => {
      window.removeEventListener('cookieConsentChanged', handleConsentChange);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default GTMLoader;
